import { jsx as _jsx } from "react/jsx-runtime";
import { FormControl as BaseFormControl } from "native-base";
const FormError = ({ error }) => (_jsx(BaseFormControl, Object.assign({ flex: 1, isInvalid: true }, { children: _jsx(BaseFormControl.ErrorMessage, Object.assign({ mt: 1, _text: { fontSize: "sm" } }, { children: error })) })));
export default FormError;
